import { render, staticRenderFns } from "./ModalProvision.vue?vue&type=template&id=dfc36266&scoped=true"
import script from "./ModalProvision.vue?vue&type=script&lang=js"
export * from "./ModalProvision.vue?vue&type=script&lang=js"
import style0 from "./ModalProvision.vue?vue&type=style&index=0&id=dfc36266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc36266",
  null
  
)

export default component.exports